import { watch } from 'vue';
import { recalculateDeliveryForm } from './salesDeliveryForm';
import { deliveryErrors } from './salesDeliveryValidation';

export function useSalesDeliveryFormState({ errors, form, participants, t }) {
  const update = (field, value) => {
    form.value = recalculateDeliveryForm({ ...form.value, [field]: value });
    delete errors.value[field];
  };

  const updateWitness = (index, field, value) => {
    const witnesses = form.value.testemunhas.map((witness, witnessIndex) =>
      witnessIndex === index ? { ...witness, [field]: value } : witness
    );
    form.value = recalculateDeliveryForm({
      ...form.value,
      testemunhas: witnesses,
    });
    delete errors.value[`witness_${index}_${field}`];
  };

  const validate = () => {
    errors.value = deliveryErrors({
      form: form.value,
      participants: participants.value,
      t,
    });
    return Object.keys(errors.value).length === 0;
  };

  watch(
    () => form.value.data_assinatura,
    () => {
      form.value = recalculateDeliveryForm(form.value);
    }
  );

  return { update, updateWitness, validate };
}
